import { BrandThemesEnum, ImageRatioEnum, PositionEnum, SizesEnum, ThemesEnum } from '@seb/web-design-system/core';
import { ArgumentsLayoutEnum } from '@seb/web-design-system/arguments';

import { WcConfig } from '../../models/wc-config.model';

export const wcKrupsConfig: WcConfig = {
  isRecipesEnabled: true,
  warranty: '/warranty',
  isThemeDark: true,
  isArgumentUnderlined: true,
  sliderCategoryOnly: true,
  isTeaserEmbedded: false,
  linkCardSubcategories: true,
  iconPos: PositionEnum.left,
  categoryPage: {
    lame1: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.right,
      theme: ThemesEnum.dark,
      backgroundTheme: ThemesEnum.dark
    },
    lame4: {
      backgroundTheme: ThemesEnum.dark
    },
    lame7: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.right,
      theme: ThemesEnum.promo,
      layout: ArgumentsLayoutEnum.divided
    },
    faq: {
      backgroundTheme: ThemesEnum.dark
    }
  },
  subCategoryPage: {
    lame1: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.right,
      theme: ThemesEnum.dark,
      backgroundTheme: ThemesEnum.dark
    },
    lame4: {
      titleTextConfig: PositionEnum.center,
      titleTheme: ThemesEnum.light,
      pushSize: SizesEnum.s,
      pushImageRatio: ImageRatioEnum.r16_9,
      pushTextConfig: PositionEnum.left,
      pushMediaConfig: PositionEnum.top,
      pushTheme: ThemesEnum.light,
      backgroundTheme: ThemesEnum.dark
    },
    lame5: {
      titleTheme: ThemesEnum.dark,
      titleTextConfig: PositionEnum.center,
      backgroundTheme: ThemesEnum.default
    },
    lame7: {
      // textConfig: PositionEnum.left,
      // mediaConfig: PositionEnum.left,
      // theme: ThemesEnum.promo,
      // argumentsLayout: ThemesEnum.promo,
      // hasGradient: ThemesEnum.promo,
      // backgroundTheme: ThemesEnum.promo,
    },
    lame8: {
      textConfig: PositionEnum.left,
      theme: ThemesEnum.dark,
      mediaConfig: PositionEnum.right,
      layout: ArgumentsLayoutEnum.default,
      hasGradient: false
    },
    lame9: {
      titleTextConfig: PositionEnum.center,
      titleTheme: ThemesEnum.light,
      backgroundTheme: ThemesEnum.default
    },
    lame10: {
      textConfig: PositionEnum.left,
      theme: ThemesEnum.dark,
      mediaConfig: PositionEnum.left,
      layout: ArgumentsLayoutEnum.default
    },
    lame11: {
      titleTextConfig: PositionEnum.center,
      titleTheme: ThemesEnum.light,
      backgroundTheme: ThemesEnum.dark
    }
  },
  accessoryPage: {
    categories: {
      titleTheme: ThemesEnum.light,
      backgroundTheme: ThemesEnum.dark
    },
    search: {
      titleTheme: ThemesEnum.dark,
      backgroundTheme: ThemesEnum.default
    }
  },
  pdp: {
    bundlesOrProducts: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    designedFor: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    productInfoArguments: {
      theme: ThemesEnum.dark,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: true
    },
    benefits: {
      backgroundTheme: ThemesEnum.default,
      titleUnderlined: true,
      titleTheme: ThemesEnum.dark
    },
    range: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    recipes: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    comparator: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    freeEditoBUArguments: {
      theme: ThemesEnum.promo,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: true
    },
    freeEditoLocalArguments: {
      theme: ThemesEnum.promo2,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: true
    },
    howTo: {
      backgroundTheme: ThemesEnum.dark,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true,
      pushTheme: ThemesEnum.dark,
      pushTitleTheme: ThemesEnum.light
    },
    accessories: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    replacementParts: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: true
    },
    ifu: {
      backgroundTheme: ThemesEnum.dark,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    faqs: {
      backgroundTheme: ThemesEnum.dark,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    disclaimer: {
      backgroundTheme: ThemesEnum.default
    }
  }
};
